
/**
 * @param {string} id
 * @returns {Record<string, any>}
 */
function readJSON(id) {
  const el = document.getElementById(id);
  if (!el || !el.textContent) return {};
  try {
    return JSON.parse(el.textContent);
  } catch (error) {
    return {};
  }
}

const config = readJSON('analytics-config'); // { containerId, debug }
const country = readJSON('analytics-country'); // { country_code, language_code }

/**
 * Identifying customer fields are withheld from the dataLayer until the visitor
 * grants analytics consent (privacy — see PR review): they must not be pushed
 * pre-consent, and this ships to real published shops. Non-identifying context
 * (logged_in, customer_type) is always attached. GTM tags are consent-gated by
 * Consent Mode too, so nothing transmits pre-consent regardless.
 */
const PII_KEYS = ['user_id', 'email', 'email_sha256', 'lifetime_transactions', 'lifetime_revenue'];

const rawUser = readJSON('analytics-user');
/** @type {Record<string, any>} */
let userPublic = {};
/** @type {Record<string, any>} */
let userIdentifiers = {};
for (const key of Object.keys(rawUser)) {
  if (PII_KEYS.indexOf(key) !== -1) userIdentifiers[key] = rawUser[key];
  else userPublic[key] = rawUser[key];
}

let identifiersReleased = false;

/** @returns {boolean} analytics consent (OneTrust C0002) granted */
function analyticsConsentGranted() {
  try {
    return (window.OnetrustActiveGroups || '').split(',').indexOf('C0002') !== -1;
  } catch (error) {
    return false;
  }
}

function releaseIdentifiers() {
  if (identifiersReleased || !analyticsConsentGranted()) return;
  identifiersReleased = true;
}
window.addEventListener('OneTrustGroupsUpdated', releaseIdentifiers);
window.addEventListener('ot:consent', releaseIdentifiers);
releaseIdentifiers(); 

function currentUser() {
  return identifiersReleased ? { ...userPublic, ...userIdentifiers } : { ...userPublic };
}

/**
 * Merge shared context, reset ecommerce when present, push to dataLayer.
 * @param {string} eventName
 * @param {Record<string, any>} [payload]
 * @returns {Record<string, any>} the pushed event object
 */
function track(eventName, payload = {}) {
  window.dataLayer = window.dataLayer || [];

  if (Object.prototype.hasOwnProperty.call(payload, 'ecommerce')) {
    window.dataLayer.push({ ecommerce: null });
  }

  const event = {
    event: eventName,
    user: currentUser(),
    country,
    ...payload,
  };

  if (config.debug) {
    // eslint-disable-next-line no-console
    console.log('[jmAnalytics]', eventName, event);
  }

  window.dataLayer.push(event);
  return event;
}

/**
 * Update the shared user object (e.g. after login/sign_up). Identifying fields
 * are routed into the consent-gated bucket; the rest are always attached.
 * @param {Record<string, any>} next
 */
function setUser(next) {
  for (const key of Object.keys(next)) {
    if (PII_KEYS.indexOf(key) !== -1) userIdentifiers[key] = next[key];
    else userPublic[key] = next[key];
  }
}

window.jmAnalytics = {
  track,
  setUser,
  config,
  get user() {
    return currentUser();
  },
  get country() {
    return country;
  },
};

export { track, setUser };
